import { render } from "./FormEditParent.vue?vue&type=template&id=77ff2586&scoped=true"
import script from "./FormEditParent.vue?vue&type=script&lang=js"
export * from "./FormEditParent.vue?vue&type=script&lang=js"

import "./FormEditParent.vue?vue&type=style&index=0&id=77ff2586&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ff2586"]])

export default __exports__